<lib-contract-state-base
    title="Estamos generando tu carta compromiso..."
    subtitle="Procesando..."
    [hasLoader]="true">
</lib-contract-state-base>


